{
  "selectCompanyStep": {
    "title": "Cuéntanos un poco más",
    "description": "Ayúdanos a que tu experiencia con Chirpee sea lo más cómoda posible",
    "companyInput": {
      "label": "¿Cuál es el nombre de tu empresa?",
      "placeholder": "Ingresa el nombre de la empresa"
    },
    "industryInput": {
      "label": "Industria de la empresa",
      "placeholder": "Selecciona una industria"
    },
    "dataRegion": {
      "label": "Región de datos",
      "placeholder": "Seleccionar región de datos",
      "tooltip": "Esto determina dónde se almacenan tus datos. No se puede cambiar después del registro.",
      "us": "Estados Unidos",
      "eu": "Unión Europea"
    },
    "nextStepButton": "Siguiente paso",
    "industries": {
      "technology": "Tecnología",
      "professionalServices": "Servicios profesionales",
      "financialServices": "Servicios financieros",
      "consulting": "Consultoría",
      "softwareDevelopment": "Desarrollo de software",
      "digitalMarketing": "Marketing digital",
      "mediaAndCommunications": "Medios y comunicaciones",
      "eCommerce": "Comercio electrónico",
      "healthTech": "Tecnología sanitaria"
    }
  },
  "selectLanguageStep": {
    "title": "Elige los idiomas del lugar de trabajo",
    "description": "Selecciona los idiomas que se admitirán en tu lugar de trabajo. Podrás editarlos más tarde en la configuración"
  }
}
